const multiLang={
    English:require('./English.json'),
    German:require('./German.json'),
    Finnish:require('./Finnish.json'),
    Norwegian: require('./Norwegian.json'),
    Swedish:require('./Swedish.json'),
    Danish:require('./Danish.json')
};

export {multiLang};